import React, {Component} from 'react';
import config from 'react-global-configuration';
import { Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
//import {Card, CardBody, CardText} from 'reactstrap';
import {Card} from 'react-bootstrap';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {Link} from "react-router-dom";
import axios from "axios";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import Select from 'react-select';
import Switch from "react-switch";
import $ from 'jquery';
import CommunicationNavbar, {navbar} from "./communicationNavbar";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import SimpleReactValidator from 'simple-react-validator';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class EmailUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            brand_file_uploaded: [],
            mvalue: { year: new Date().getFullYear(), month: 11 },
            _notificationSystem: null,
            timer: null,
            loading: true,
            isSubmit: false,
            file_name: "",
            notify: null,
            activer:[],
            activer_copy: [],
            is_download: false,
            uploadDropdown: false,
            errorModel: false,
            noErrorModel: false,
            file_id_got: null,
            report_file_name: null,
            error_message: null,
            error_message_header: null,
            open_instructions: false,
            emiMenus:[],
            party_options: [
                { value: 'Brand', label: 'Brand' },
                { value: 'Merchant', label: 'Merchant' }
            ],
            party_list: [],
            selected_party_type: null,
            selected_party: null,
            selected_party_type2: null,
            selected_party2: null,
            upload_user_type: null,
            partyTypeID: '',
            partyTypeValue: null,
            partyID: '',
            partyValue: null,
            newEmailModel: false,
            email: '',
            receiver_type: '',
            brand_list: [],
            selected_brand: '',
            selected_brand_code: '',
            selected_brand_2: [],
            party_master_id: null,
            add_disable: false,
            edit_email: '',
            edit_receiver_type: '',
            edit_selected_brand: '',
            edit_selected_brand_code: '',
            edit_party_master_id: null,
            editEmailModel: false,
            update_disable: false,
            edit_disable: false,
            email_id: null
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentWillMount(){
        this.validator = new SimpleReactValidator();
        this.validator2 = new SimpleReactValidator();
    }

    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        this.getPartyID();
        this.getPartyList();
        this.getBrandList();
        //var _notificationSystem = this.refs.notificationSystem;
        // this.getBrandUploadedData();
    }

    onChangeInput(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    changeReceiverType(e) {
        this.setState({
            receiver_type : e.target.value
        })
    }

    changeEditReceiverType(e) {
        this.setState({
            edit_receiver_type : e.target.value
        })
    }

    getPartyName(party_master_id) {
        this.setState({
            loading: true
        })
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        //console.log(this.state.edit_party_master_id);
        axios.get(config.get('API_URL') + '/brandemi/get_party_name',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: party_master_id
            }
        }).then(response => {
            console.log(response);
            response.data.map((values, index) => {
                this.setState({
                    edit_selected_brand: values.party_name,
                    editEmailModel: true
                })
            });  
            this.setState({
                loading: false
            })
        });
    }

    openEditEmail(id, party_master_id, receiver_type, email) { 
        //console.log(party_master_id)
        this.setState({
            email_id: id,
            edit_email: email,
            edit_receiver_type: receiver_type,
            edit_selected_brand_code: party_master_id,
            edit_party_master_id: party_master_id
        }, () => {
            this.getPartyName(party_master_id);
        });
    }

    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            if(response.data.length == 0 && (decoded.userGroup == 1 || decoded.userGroup == '1')){
                this.setState({
                    party_master_id: 3,
                    loading: false,
                    user_id: decoded._id
                });
                this.getBrandUploadedData(); 
            }
            else{
                //console.log(response.data);
                response.data.map((values, index) => {
                    //console.log(values.party_id);
                    this.setState({
                        party_master_id: values.party_id
                    })
                })
                this.setState({
                    party_id_mapper: response.data
                });
                $('#party_showTable').DataTable();
                this.setState({
                    loading: false,
                    user_id: decoded._id
                });
                this.getBrandUploadedData();
            }
        });
        
        
    }

    getBrandList(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/get_party_list', {
            party_type1: 'Brand'
        }, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response);
            let brand_list = [];
            this.setState({
                brand_list: [],
                selected_party: null
            });
            response.data.map((values, index) => {
                brand_list.push({value: values.id, label: values.party_name});
            });
            this.setState({
                brand_list: brand_list,
                loading: false
            });
        });
        return null;
    }

    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    openInstructions(){
        this.setState({
            open_instructions: !this.state.open_instructions
        });
        
    }

    onChangeHandler = event => {
        var file = event.target.files[0];
        var ext = this.getFileExtension(file.name);
        if (ext === 'csv') {
            this.setState({
                selectedFile: file,
                file_name: file.name
            });
        } else {
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                selectedFile: file
            });
        }
    };

    handleChange(checked) {
        //console.log(this.state.checked);
        //console.log(e.target.value);
        this.setState({
            checked
        });
        //this.setState({
        //    changedItems: {...this.state.changedItems, [id]:e.target.value},
        //    isChange: true
        //});
    }


    updateBrandValue = (valuer) => {
        this.setState({
            selected_brand: valuer.label,
            selected_brand_2: [{value: valuer.value, label: valuer.label}],
            selected_brand_code: valuer.value,
            party_master_id: valuer.value,
            loading: false
        });
        
    };

    getBrandUploadedData(){
        this.setState({
            loading: true
        })
        if ($.fn.DataTable.isDataTable('#brandViewTable')) {
            $('#brandViewTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/get_email_users', {
            party_type: this.state.partyTypeID,
            party_id: this.state.partyID
        }, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //let brand_list = [];
            // this.setState({
            //     brand_list: [],
            //     selected_party: null
            // });
            //console.log(response.data.data);
            response.data.data.map((value, index) => {
                //brand_list.push({value: value.id, label: value.party_name});
                let status = false;
                if(value.active===1) { status = true;}
                this.setState({
                    activer: {...this.state.activer, [value.id]:status }
                });
            });
            this.setState({
                //activer_copy: this.state.activer,
                brand_file_uploaded: response.data.data,
                //brand_list: brand_list,
                loading: false
            })
            $('#brandViewTable').DataTable({
                "oLanguage": {
                    "sEmptyTable": "There are no schemes created"
                }
            });
        });
        return null;
    }

    downloadCSV = (file_id, file_value) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: config.get('API_URL') + "/brandemi/download_csv?file_id=" + file_id,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName= null;
                //console.log(file_value);
                //console.log(xhr.getResponseHeader('Content-Disposition'));
                if(file_id == '7md38Hhdad3_brand_product_master_template.csv'){
                    fileName = 'brand_product_master_template.csv';
                }
                else{
                    fileName= file_value;
                }
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                // console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                //console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };

    downloadReportCSV = (file_id, file_value) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: config.get('API_URL') + "/brandemi/download_report_csv?file_id=" + file_value,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName= file_value;
                //console.log(file_value);
                //console.log(xhr.getResponseHeader('Content-Disposition'));
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                // console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                //console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };

    fileUploadHandler = () => {
        const timer1 = (Date.now()).toString();
        //console.log(timer1);
        this.setState({
            timer: timer1,
            isSubmit: true,
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('file', this.state.selectedFile);
        data.append('userID', decoded._id);
        data.append('timer', this.state.timer);
        data.append('timer1', timer1);
        // let random_string = Date.now()+'_'+req.body.userID+'_';
        //console.log(decoded.userGroup);
        data.append('userGroup', decoded.userGroup);
        data.append('party_master_id', this.state.party_master_id);
        if(this.state.selectedFile == null){
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                isSubmit: false,
                loading: false
            });
        }
        else{
            var file = this.state.selectedFile; //console.log(data);
            var ext = this.getFileExtension(file.name);
            if (ext === 'csv') {
                axios.post(config.get('API_URL') + "/brandemi/new_upload_scheme_master/", data, {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }
                })
                .then(res => {
                    //console.log(res.data);
                    this.setState({
                        file_id_got: res.data.file_id,
                        report_file_name: res.data.report_file_name
                    });
                    //console.log(res.data.notify);
                    //console.log(res.data.inconsistent);
                    if (res.data.flag == 2){
                        this.handleNotificationClick("tr", 2, "File with same name uploaded. If you continue, old file will be overwritten.");
                    }
                    else if(res.data.flag == 3){
                        this.setState({
                            isSubmit: false,
                            loading: false,
                            notify: res.data.notify,
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name,
                            error_message: res.data.total_value + '/' + res.data.total,
                            error_message_header: 'Failure'
                        });
                        this.handleNotificationClick("tr", 3, "No valid data to upload. File not uploaded");
                        
                    }
                    else if(res.data.flag == 4){
                        this.handleNotificationClick("tr", 3, "Columns are incorrect in your csv");
                    }
                    else if (res.data.success !== undefined && res.data.notify !== undefined && res.data.inconsistent === 0 && res.data.error2 === 0) {
                        this.setState({
                            isSubmit: false,
                            loading: false,
                            notify: res.data.notify,
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name,
                            error_message: res.data.total_value + '/' + res.data.total
                        });
                        //console.log("call show method on success");
                        this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
                        this.toggleNoErrorModel.bind(this);
                        this.setState({
                            error_message_header: 'Success'
                        })
                        this.getBrandUploadedData();
                        //this.props.history.push('/admin/brand-product-master')
                    } 
                    
                    else {
                        if (res.data.error2 === 1){
                            this.setState({
                                error_message_header: 'Failure'
                            })
                            this.getBrandUploadedData();
                        }
                        else{
                            this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
                            this.toggleNoErrorModel.bind(this);
                            this.setState({
                                error_message_header: 'Success'
                            })
                            this.getBrandUploadedData();
                        }
                        this.setState({
                            isSubmit: false,
                            error_message: res.data.total_value + '/' + res.data.total,
                            loading: false,
                            notify: res.data.notify,
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name
                        });
                    }
                })
                .catch(err => { 
                    console.log(err);// then print response status
                    this.handleNotificationClick("tr", 3, "Something Wrong!");
                    this.setState({
                        isSubmit: false,
                        loading: false
                    });
                    // this.openSectionToMap(true); // remove and place in success block
                })
            }
            else {
                this.handleNotificationClick("tr", 3, "Please upload valid file");
                this.setState({
                    isSubmit: false,
                    loading: false
                });
            }
        }
    };

    goBack = () => {
        //this.props.history.push('/admin/brand-emi')
    }

    activeHandler() {
        this.setState({
            isSubmit: true,
            loading: true,
            update_disable: true
        });
        if(this.state.activer2.length == 0 || this.state.activer2.length == 'undefined'){
            this.handleNotificationClick("tr", 3, "No changes applicable");
            this.setState({
                isSubmit:false,
                loading:false,
                update_disable: false
            });
        }
        else{
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('userID', decoded._id);
        data.append('mappings', JSON.stringify(this.state.activer2));
        data.append('userGroup', decoded.userGroup);
        data.append('party_master_id', this.state.party_master_id);
        axios.post(config.get('API_URL') + "/brandemi/active_email_config", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                //console.log(res);
                if(res.data.flag == '1'){
                    this.handleNotificationClick("tr", 1, 'Record has been updated successfully');
                } 
                else {
                    this.handleNotificationClick("tr", 3, "Something wrong!");
                }
                this.setState({
                    isSubmit:false,
                    loading:false,
                    update_disable: false
                });
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Unable to connect to server. Try again later");
                this.setState({
                    isSubmit:false,
                    loading:false,
                    update_disable: false
                })
            })
        }
    };
    
    changeStatus(id, checked) {
        //let status = 0;
        //if(checked===true){ status = 1 } else { status = 0 }
        this.setState({
            activer2: {...this.state.activer2, [id]:checked },
            activer: {...this.state.activer, [id]:checked }
        })
    }

    gotoCreateSchemes = () => {
        this.props.history.push('/admin/admin-new-create-schemes');
    }

    getPartyList() {
        const token = localStorage.usertoken;
        axios.post(config.get('API_URL')+'/brandemi/get_party_list_filter', {
                party_type: this.state.partyTypeID
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => { //console.log(response);
            let party_list = [];
            this.setState({
                party_list: [],
                selected_party: null
            });
            response.data.data.map((values, index) => {
                if (values.party_name != 'Admin'){
                    party_list.push({value: values.id, label: values.party_name})
                }
            });
            this.setState({
                party_list: party_list,
                loading: false
            })
        });
    }

    toggleErrorModel() {
        this.setState({
            errorModel: !this.state.errorModel
        });
    }

    updatePartyType(optionSelected){
        this.setState({
            loading: true
        })
        let value='';
        let partyTypeArray = [];
        if(optionSelected.length<1){
            value = null;
            partyTypeArray = '';
        }
        else{
            optionSelected.map((partytypeids, i) => {
                partyTypeArray.push(partytypeids.value)
            });
        }
        this.setState({
            partyTypeID:partyTypeArray,
            partyTypeValue:optionSelected,
            uploadDropdown: false,
            // partyID: '',
            // partyValue: null,
            party_list: [],
            loading: false,
            //activer: activer_copy
        }, () =>{
            this.getPartyList();
            this.getBrandUploadedData();
        });
        
        // this.setState({
        //     selected_party_type: valuer.value,
        //     selected_party_type2: [{value: valuer.value, label: valuer.label}],
            
        //     upload_user_type: 7,
            
        //     selected_party: null,
        //     selected_party2: null,
        //     party_master_id: 5,
        //     party_list: []
        // }, () => {
        //     this.getPartyList();
        // });
        
    };

    updatePartyValue(optionSelected){
        this.setState({
            loading: true
        })
        let value='';
        let partyArray = [];
        if(optionSelected.length<1){
            value = null;
            partyArray = '';
        }
        else{
            optionSelected.map((partyids, i) => {
                partyArray.push(partyids.value)
            });
        }
        this.setState({
            partyID:partyArray,
            partyValue:optionSelected,
            uploadDropdown: false,
            loading: false,
            //activer: activer_copy
        }, () => {
            this.getBrandUploadedData();
        });
        
        // this.setState({
        //     selected_party: valuer.value,
        //     selected_party2: [{value: valuer.value, label: valuer.label}],
        //     party_master_id: valuer.value,
        //     loading: false,
        //     uploadDropdown: false
        // }, () => {
        //     this.getBrandUploadedData();
        // });
    };

    downloadReport(){
        //console.log(this.state.report_file_name);
        this.downloadReportCSV.bind(this, 1, this.state.report_file_name);
    }


    toggleNoErrorModel() {
        this.setState({
            noErrorModel: !this.state.noErrorModel
        });
    }

    gotoUploadedFile = (e) => {
        e.preventDefault();
        let pusher = '/admin/scheme-viewer/' + this.state.file_id_got
        this.props.history.push(pusher)
    }


    toggleNewEmailModel(modal_type) {
        this.validator.hideMessages();
        this.setState({
            newEmailModel: !this.state.newEmailModel
        })
    }

    toggleEditEmailModel(modal_type) {
        this.validator2.hideMessages();
        this.setState({
            editEmailModel: !this.state.editEmailModel
        })
    }

    addEmail() {
        if (this.validator.allValid()) {
            this.setState({
                loading: true,
                add_disable: true
            })
            const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            const data = new FormData();
            data.append('user_id', decoded._id);
            data.append('email', this.state.email);
            data.append('receiver_type', this.state.receiver_type);
            data.append('brand_code', this.state.selected_brand_code);
            data.append('brand_name', this.state.selected_brand);

            axios.post(config.get('API_URL') + '/brandemi/brand_email_register', data, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                if(response.data.flag == '1'){
                    this.handleNotificationClick("tr", 1, "Email is successfully registered");
                    this.toggleNewEmailModel();
                    this.getBrandUploadedData();
                }
                else if(response.data.flag == '2'){
                    this.handleNotificationClick("tr", 3, "Email already exists for that brand");
                }
                this.setState({
                    loading: false,
                    add_disable: false
                })

                // console.log("abbaba")
                // console.log(response);
                if (response.data.error) {
                    this.handleNotificationClick("tr", 3, "Something went wrong");
                    this.setState({
                        loading: false,
                        add_disable: false
                    })
                } else {
                    //this.props.handleClick("tr", 1, "Record has been successfully Added.");
                    this.setState({
                        newUserModel: false,
                        loading: false,
                        add_disable: false
                    });
                }
            });
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }
    }

    editEmail() {
        //console.log("Hello")
        if (this.validator2.allValid()) {
            this.setState({
                loading: true,
                edit_disable: true
            })
            const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            const data = new FormData();
            data.append('user_id', decoded._id);
            data.append('email_id', this.state.email_id)
            data.append('email', this.state.edit_email);
            data.append('receiver_type', this.state.edit_receiver_type);
            data.append('party_master_id', this.state.edit_party_master_id);

            axios.post(config.get('API_URL') + '/brandemi/brand_email_edit', data, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                if(response.data.flag == '1'){
                    this.handleNotificationClick("tr", 1, "Email is successfully edited");
                    this.toggleEditEmailModel();
                    this.getBrandUploadedData();
                }
                else if(response.data.flag == '-1'){
                    this.handleNotificationClick("tr", 3, "Email already exists for that brand");
                }
                this.setState({
                    loading: false,
                    add_disable: false
                })

                // console.log("abbaba")
                // console.log(response);
                if (response.data.error) {
                    this.handleNotificationClick("tr", 3, "Something went wrong");
                    this.setState({
                        loading: false,
                        edit_disable: false
                    })
                } else {
                    //this.props.handleClick("tr", 1, "Record has been successfully Added.");
                    this.setState({
                        editUserModel: false,
                        loading: false,
                        edit_disable: false
                    });
                }
            });
        } else {
            this.validator2.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }
    }

    uploadDropdownHandler(){
        this.setState({
            newEmailModel: true
        })
    }


    render() {

        let brand_render_list = this.state.brand_list;
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };

        let party_render = this.state.party_options;
        let party_render_list = this.state.party_list;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        

        let brand_file_data = this.state.brand_file_uploaded.map((value, index) =>{
            
            
                return (
                    <tr key={index + 1}>
                    <td>{value.party_type}</td>
                    <td>{value.party_name}</td>
                    <td>{value.email}</td>
                    <td>{value.receiver_type}</td>
                    <td>
                    <Switch className="react-switch" height={20} width={38} id={value.id + '_'} onChange={this.changeStatus.bind(this, value.id)} checked={(this.state.activer[value.id])? true : false}></Switch>
                    </td>
                    <td>
                        <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                        <Link className="viewButton" onClick={this.openEditEmail.bind(this, value.id, value.party_master_id, value.receiver_type, value.email)} data-tip="Edit Email"><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>
                    </td>
                </tr>
                )
            //}
            
        });

        // let error_message_headere = () => {
        //     let value_header = this.state.error_message_header;
        //     if(value_header == 'Failure'){
        //         return(
        //             <div className="row">
        //                 <div className="col-md-12"> 
        //                     <div className="redtexter">{value_header}</div>
        //                 </div>    
        //             </div>
        //         );
        //     }
        //     else if(value_header == 'Success'){
        //         return(
        //             <div className="row">
        //                 <div className="col-md-12"> 
        //                     <div className="greentexter">{value_header}</div>
        //                 </div>    
        //             </div>
        //         );
        //     }
        // }

        let party_shower = () => {
            if(decoded.userGroup == 1 || decoded.userGroup == '1'){
                return(
                    <div className="row top-margin-30">
                        <div className="col-md-3">
                            <Label>Select party type</Label>
                            <ReactMultiSelectCheckboxes name={"party_type_filter"}
                                components={{ MenuList }}
                                value={this.state.partyTypeValue}
                                styles={customStyles} className="report-listbox"
                                onChange={this.updatePartyType.bind(this)}
                                options={party_render}
                                placeholderButtonLabel="Select [Party Type]"
                                // isClearable={true}
                                
                            />
                        </div>  
                        <div className="col-md-3">
                            <Label>Select party</Label>
                            <ReactMultiSelectCheckboxes name={"party_name_filter"}
                                components={{ MenuList }}
                                value={this.state.partyValue}
                                styles={customStyles} className="report-listbox"
                                onChange={this.updatePartyValue.bind(this)}
                                options={party_render_list}
                                placeholderButtonLabel="Select [Party Name]"
                                // isClearable={true}
                                
                            />
                        </div> 
                    </div>
                )
            }
            else{
                return(
                    <div></div>
                )
            }
        }
        

        return (
            <div className="longcontent">
                <CommunicationNavbar/>
            <div className="container-fluid">
            <div className="card-query-builder">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <Modal isOpen={this.state.newEmailModel} toggle={this.toggleNewEmailModel.bind(this)} >
                    <ModalHeader toggle={this.toggleNewEmailModel.bind(this)}>Add Email User</ModalHeader>
                                <ModalBody className="user_form_fields">
                                    {/* <h5>Add Email</h5> */}
                                    <div className="row">
                                    <div className="col-md-4 col-sm-12">
                                            <FormGroup>
                                                <Label for="org">Select Brand* </Label>
                                                <Select name={"organization"}
                                                    value={this.state.selected_brand_2}
                                                    onChange={this.updateBrandValue.bind(this)}
                                                    options={brand_render_list}
                                                    placeholder="Select Brand"
                                                    // isClearable={true}
                                                />
                                                {this.validator.message('organization', this.state.selected_brand, 'required')}
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                            <FormGroup>
                                                <Label for="eamil">Email*</Label>
                                                <Input id="email" name="email" autoComplete="new-password" value={this.state.email} onChange={this.onChangeInput.bind(this)}/>
                                                {this.validator.message('email', this.state.email, 'required|email')}
                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                        <   FormGroup>
                                                <Label for="password">Title*</Label>
                                                <select name="contact_title" className="form-control"
                                                    value={this.state.receiver_type} onChange={this.changeReceiverType.bind(this)}>
                                                    <option value=" ">Select</option>
                                                    <option value="to">to</option>
                                                    <option value="cc">cc</option>
                                                </select>
                                                {this.validator.message('receiver_type', this.state.receiver_type, 'required')}
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className="ro-sep"></div>
                                    
                                </ModalBody>
                                <ModalFooter>
                                    <div className="col-md-6 pull-left text-left">
                                        Fields marked with * are mandatory
                                    </div>
                                    <div className="col-md-6">
                                        <Button color="primary" disabled={this.state.add_disable} onClick={this.addEmail.bind(this)}>Add Email</Button>
                                        <Button color="secondary" disabled={this.state.add_disable} onClick={this.toggleNewEmailModel.bind(this)}>Cancel</Button>
                                    </div>
                                </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.editEmailModel} toggle={this.toggleEditEmailModel.bind(this)} >
                    <ModalHeader toggle={this.toggleEditEmailModel.bind(this)}>Edit Email User</ModalHeader>
                                <ModalBody className="user_form_fields">
                                    {/* <h5>Add Email</h5> */}
                                    <div className="row">
                                    <div className="col-md-4 col-sm-12">
                                            <FormGroup>
                                                <Label for="org">Brand </Label>
                                                    <Input id="edit_brand" name="edit_brand" autoComplete="new-password" value={this.state.edit_selected_brand} disabled={true}/>
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                            <FormGroup>
                                                <Label for="edit_eamil">Email*</Label>
                                                <Input id="edit_email" name="edit_email" autoComplete="new-password" value={this.state.edit_email} onChange={this.onChangeInput.bind(this)}/>
                                                {this.validator2.message('edit_email', this.state.edit_email, 'required|email')}
                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                        <   FormGroup>
                                                <Label for="password">Title*</Label>
                                                <select name="edit_recevier_type" className="form-control"
                                                    value={this.state.edit_receiver_type} onChange={this.changeEditReceiverType.bind(this)}>
                                                    <option value=" ">Select</option>
                                                    <option value="to">to</option>
                                                    <option value="cc">cc</option>
                                                </select>
                                                {this.validator2.message('edit_receiver_type', this.state.edit_receiver_type, 'required')}
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className="ro-sep"></div>
                                    
                                </ModalBody>
                                <ModalFooter>
                                    <div className="col-md-6 pull-left text-left">
                                        Fields marked with * are mandatory
                                    </div>
                                    <div className="col-md-6">
                                        <Button color="primary" disabled={this.state.edit_disable} onClick={this.editEmail.bind(this)}>Edit Email</Button>
                                        <Button color="secondary" disabled={this.state.edit_disable} onClick={this.toggleEditEmailModel.bind(this)}>Cancel</Button>
                                    </div>
                                </ModalFooter>
                </Modal> 
                <div className="pt-5" >
                    <div className="card">
                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={20}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="header">
                            
                            <h4 className="title pull-left">Email Users</h4>
                            <button onClick={this.uploadDropdownHandler.bind(this)} className="btn btn-primary btn-capitalize pull-right">Add Email</button>
                            
                        </div>
                        
                        <div className="content">
                        {party_shower()}
                            <div className="row">
                                <div className="container-fluid">
                                    <div className="table-full-width table-responsive-bemi notablerightmargin top-pad-5">    
                                        <table className="table table-striped table-hover" id="brandViewTable">
                                            <thead>
                                                <tr>
                                                    <th>Party Type</th>
                                                    <th>Party Name</th>
                                                    <th>Email</th>
                                                    <th>Receiver Type</th>
                                                    <th>Active</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {brand_file_data}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className ="col-md-12">
                                <button disabled={this.state.update_disable} onClick={this.activeHandler.bind(this)} className="btn btn-primary btn-capitalize pull-right">Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            </div>
        );
    }
}

export default EmailUsers;